module.exports = __webpack_public_path__ + "img/overview-icon.2e6eef0c.svg";